export const DEFAULT_MAXIMUM_FILE_UPLOAD_SIZE = 40;

export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / k ** i).toFixed(dm)) + ' ' + sizes[i];
};

export const fileSizeInMegaBytes = bytes => {
  return bytes / (1024 * 1024);
};

export const checkFileSizeLimit = (file, maximumUploadLimit) => {
  const fileSize = file?.file?.size || file?.size;
  const fileSizeInMB = fileSizeInMegaBytes(fileSize);
  return fileSizeInMB <= maximumUploadLimit;
};

export const resolveMaximumFileUploadSize = value => {
  const parsedValue = Number(value);

  if (!Number.isFinite(parsedValue) || parsedValue <= 0) {
    return DEFAULT_MAXIMUM_FILE_UPLOAD_SIZE;
  }

  return parsedValue;
};

/**
 * O tipo OTIMISTA do anexo — o que a bolha temporária usa enquanto o envio corre, antes de o
 * servidor responder com o `file_type` de verdade (que ele decide pelo CONTEÚDO, não pelo nome).
 *
 * Reconhecer `audio` aqui é o que faz a nota de voz recém-gravada já nascer com player em vez
 * de virar um cartão de download que só se conserta quando a resposta chega. `video` fica de
 * fora de propósito: hoje ele cai em `file` até o servidor responder, e mexer nisso mudaria a
 * aparência de um envio que ninguém reclamou.
 */
export const getFileTypeFromMime = (mimeType = '') => {
  if (mimeType.includes('image')) return 'image';
  if (mimeType.includes('audio')) return 'audio';
  return 'file';
};
